import React from "react";

/**
 * JsIcon — Iconos custom de JustSapiens (PNG).
 *
 * Disponibles:
 *   - ciudadano
 *   - juzgados
 *   - abogado
 *   - doctrina
 *   - jurisprudencia
 *   - normas
 *   - fuentes-normativas
 *
 * Uso:
 *   <JsIcon name="abogado" size={48} />
 *   <JsIcon name="normas" size={40} className="rounded-sm" />
 *
 * Wraps en un cuadro decorativo cream con sombra suave (estilo JustSapiens).
 */
const ICON_MAP = {
  ciudadano: "/brand/icons/icon_ciudadano.png",
  juzgados: "/brand/icons/icon_juzgados.png",
  abogado: "/brand/icons/icon_abogado.png",
  doctrina: "/brand/icons/icon_doctrina.png",
  jurisprudencia: "/brand/icons/icon_jurisprudencia.png",
  normas: "/brand/icons/icon_normas.png",
  "fuentes-normativas": "/brand/icons/icon_fuentes-normativas.png",
};

export function JsIcon({ name, size = 56, alt = "", className = "" }) {
  const src = ICON_MAP[name];
  if (!src) return null;
  return (
    <img
      src={src}
      alt={alt}
      aria-hidden={alt ? "false" : "true"}
      className={`object-contain ${className}`}
      style={{ width: size, height: size }}
      loading="lazy"
    />
  );
}

/**
 * JsIconBox — Variante con fondo cream cuadrado para tarjetas.
 */
export function JsIconBox({ name, size = 48, boxSize = 72, alt = "", className = "" }) {
  return (
    <div
      className={`inline-flex items-center justify-center bg-brand-cream rounded-sm ${className}`}
      style={{ width: boxSize, height: boxSize }}
    >
      <JsIcon name={name} size={size} alt={alt} />
    </div>
  );
}
